import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { DateTime } from 'luxon';

@Component({
  templateUrl: './input-true-false-session.component.html',
  styles: [
    `
    .mat-button-toggle-group-appearance-standard {
      border: none !important;
      border-radius: 0px;
    }
    mat-button-toggle {
      border: 3px solid #fff !important;
    }

    mat-button-toggle.selected {
      border: 3px solid #076634 !important;
    }
    `
  ]
})
export class InputTrueFalseSessionComponent {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  inputForm: FormGroup = this.fb.group({
    value: [undefined, [Validators.required]]
  });

  constructor(
    private fb: FormBuilder
  ) { }

  submit() {
    if (!this.inputForm.invalid) {
      const now = DateTime.local().toJSDate();
      const value: SessionStepValue = {
        workflowId: this.step.workflowId,
        workflowStepId: this.step.workflowStepId,
        sessionId: this.step.sessionId,
        timestamp: now,
        type: SessionStepValueType.inputBoolean,
        value: { input: this.inputForm.value.value === 'true' } as InputJson
      };
      this.commitAndNext.emit({ ...this.step, completedOn: now, values: [value] });
    }
  }



}
